import { inject, injectable } from "inversify";
import { IntSelectModel, ICPLCasesClient, CaseModel, NewCaseModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { CaseStatusBehaviourTypes } from "global/enums";
import { timeRemainingHelper } from "cpl-react-common/Helpers/TimeRemainingHelper";

type TimeRemaining = {
  timeRemainingString: string;
  taskOverdue: boolean;
  dueToday: boolean;
};

export interface ICasesService {
  getCase(caseID: number): Promise<CaseModel>;
  getCases(meetingID?: number): Promise<CaseModel[]>;
  createCase(newCaseStatusTypeModel: NewCaseModel): Promise<number>;
  updateCase(caseStatusTypeModel: CaseModel): Promise<void>;
  getCaseSelectModels(): Promise<IntSelectModel[]>;
  changeCaseStatus(caseID: number, caseStatusTypeID: number): Promise<void>;
  getTimeRemaining(userTaskModel: CaseModel): TimeRemaining;
}

@injectable()
export class CasesService implements ICasesService {
  @inject(SERVICE_TYPES.CPLCasesClient) cplCasesClient!: ICPLCasesClient;

  async getCase(caseID: number): Promise<CaseModel> {
    return this.cplCasesClient.getCase(caseID);
  }

  async getCases(meetingID?: number): Promise<CaseModel[]> {
    return this.cplCasesClient.getCases(meetingID);
  }

  async createCase(newCaseModel: NewCaseModel): Promise<number> {
    return this.cplCasesClient.createCase(newCaseModel);
  }

  async updateCase(caseModel: CaseModel): Promise<void> {
    return this.cplCasesClient.updateCase(caseModel);
  }

  async getCaseSelectModels(): Promise<IntSelectModel[]> {
    return this.cplCasesClient.getCaseSelectModels();
  }

  async changeCaseStatus(caseID: number, caseStatusTypeID: number): Promise<void> {
    return this.cplCasesClient.changeCaseStatus(caseID, caseStatusTypeID);
  }

  getTimeRemaining(caseModel: CaseModel): TimeRemaining {
    return timeRemainingHelper(
      caseModel.caseStatusTypeID,
      undefined,
      caseModel.slaTarget,
      CaseStatusBehaviourTypes.Closed
    );
  }
}
